import {
  Component,
  OnInit,
  computed,
  signal,
  inject,
  DestroyRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule, FormGroup } from "@angular/forms";
import {
  RouterModule,
  ActivatedRoute,
  ParamMap,
  Router,
} from "@angular/router";
import { GlobalService } from "../../shared/services/global.service";
import {
  faMapMarkerAlt,
  faTimes,
  faExternalLink,
  faCheck,
  faSearch,
  faEye,
  faDna,
  faLink,
  faEnvelope,
  faPhone,
  faEdit,
  faPlus,
  faSave,
  faChevronUp,
  faChevronDown,
  faCalendar,
  faInfoCircle,
  faUndo,
  faLanguage,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faXTwitter,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import {
  jobpostingHours,
  jobpostingTypes,
} from "../../shared/services/job.service";
import { LocaleService } from "../../shared/services/locale.service";
import { InterestService } from "../../shared/services/interest.service";
import { ModalService } from "../../shared/services/modal.service";
import { FormDialogService } from "../../shared/forms/form-dialog.service";
import {
  buildJobPostingDefinition,
  saveJobPosting,
  type JobPostingModel,
} from "../../shared/entities/job-posting/job-posting";
import { MatchService } from "../../shared/services/match.service";
import { Observable, of, forkJoin } from "rxjs";
import { ModalCompanyProfileTradenameComponent } from "./modal-company-profile-tradename/modal-company-profile-tradename.component";
import { ModalCompanyProfileExperiencedayComponent } from "./modal-company-profile-experienceday/modal-company-profile-experienceday.component";
import { ModalCompanyProfilePhotoComponent } from "./modal-company-profile-photo/modal-company-profile-photo.component";
import { ModalCompanyProfileVideoComponent } from "./modal-company-profile-video/modal-company-profile-video.component";
import { empty, sortArrayOnKey } from "../../functions";
import { catchError, map } from "rxjs/operators";
import {
  alertMessages,
  AlertService,
} from "../../shared/services/alert.service";
import { ModalCompanyProfileAvatarComponent } from "./modal-company-profile-avatar/modal-company-profile-avatar.component";
import { companyprofilePlaceholder } from "../../model/model.companyprofile";
import { Company } from "../../api/models/company";
import { ModalCompanyProfileCoverComponent } from "./modal-company-profile-cover/modal-company-profile-cover.component";
import { VideoService } from "../../shared/services/video.service";
import { RoleTypes } from "../../guards/roletypes";
import { ExperiencedayService } from "../../shared/services/experienceday.service";
import { ElectionService } from "../../shared/services/election.service";
import { ModalCompanyProfileAccountComponent } from "./modal-company-profile-account/modal-company-profile-account.component";
import { ModalCompanyProfileAssignmentComponent } from "./modal-company-profile-assignment/modal-company-profile-assignment.component";
import { ModalCompanyProfileJobmatchesComponent } from "./modal-company-profile-jobmatches/modal-company-profile-jobmatches.component";
import { ElectionService as ApiElectionService } from "../../api/services/election.service";
import { Election } from "../../api/models/election";
import { ModalCompanyElectionSignupComponent } from "./modal-company-election-signup/modal-company-election-signup.component";
import { Account } from "../../api/models/account";
import { AuthenticationService } from "../../shared/services/authentication.service";
import { environment } from "../../../environments/environment";
import {
  BlockQuote,
  Bold,
  ClassicEditor,
  EditorConfig,
  Heading,
  Italic,
  Link,
  List,
  Table,
  TableToolbar,
} from "ckeditor5";
import { APP_CONFIG } from "src/assets/config/app-config";
import { studentprofilePlaceholder } from "../../model/model.studentprofile";
import { CompanyService as ApiCompanyService } from "../../api/services/company.service";
import { MeetDayService } from "../../api/services/meet-day.service";
import { MeetDay } from "../../api/models/meet-day";
import { MeetDayStudent } from "../../api/models/meet-day-student";
import { StudentProfileService } from "../../api/services/student-profile.service";
import { AreaOfInterestService } from "../../api/services/area-of-interest.service";
import { MatchCompetencyService } from "../../api/services/match-competency.service";
import { JobPostingService } from "../../api/services/job-posting.service";
import { StudentProfile } from "../../api/models/student-profile";
import { Education } from "../../api/models/education";
import { AreaOfInterest } from "../../api/models/area-of-interest";
import { Interests } from "../../api/models/interests";
import { WorkExperience } from "../../api/models/work-experience";
import { MatchCompetency } from "../../api/models/match-competency";
import { MatchCriterion } from "../../api/models/match-criterion";
import { MatchCriterionCompetency } from "../../api/models/match-criterion-competency";
import { CompanyTrademark } from "../../api/models/company-trademark";
import { CompanyAccount } from "../../api/models/company-account";
import { ExperienceDay } from "../../api/models/experience-day";
import { CompanyImageReference } from "../../api/models/company-image-reference";
import { JobPosting } from "../../api/models/job-posting";
import { EducationLevel } from "../../api/models/education-level";
import { PlannedExperienceDay } from "../../api/models/planned-experience-day";
import { SortType } from "../../api/models/sort-type";
import { TranslationService } from "../../shared/services/translation.service";
import {
  ModalTranslateLanguagesComponent,
  ModalTranslateLanguagesData,
  ModalTranslateLanguagesResult,
} from "../../shared/components/modal-translate-languages/modal-translate-languages.component";
import {
  TranslationLanguage,
  TranslationResults,
} from "../../shared/types/translation.types";
import { StudentProfileCv } from "../../api/models/student-profile-cv";
import { FormlyFieldConfig, FormlyModule } from "@ngx-formly/core";
import { TranslateModule, TranslatePipe } from "@ngx-translate/core";
import {
  NgbCarouselModule,
  NgbPaginationModule,
} from "@ng-bootstrap/ng-bootstrap";
import { LoaderComponent } from "../../core/loader/loader.component";

import { JobCardComponent } from "../../shared/components/network-card/job-card.component";
import { StudentCardComponent } from "../../shared/components/network-card/student-card.component";
import { SelectorAreaofinterestsComponent } from "../../core/selector-areaofinterests/selector-areaofinterests.component";

/**
 * TODO: Remove this interface and normalizeMeetdayStudent() once backend updates
 * MeetDayStudent to include the full StudentProfile instead of just studentProfileId.
 * This will eliminate the need for separate profile fetching and client-side merging.
 */
interface NormalizedMeetdayStudent {
  id: string;
  firstName: string;
  lastName: string;
  name: string;
  avatarUri: string;
  contactEmailAddress: string;
  homeAddress: {
    street: string;
    number: string;
    numberSuffix: string;
    city: string;
    postalCode: string;
    country: string;
    latitude: number | null;
    longitude: number | null;
  };
  educations: Education[];
  highestEducation: Education | null;
  areaOfInterests: AreaOfInterest[];
  interests: Interests[];
  workExperiences: WorkExperience[];
  studentProfileCvs: StudentProfileCv[];
  profileStrength: number;
  currentUserMatchPercentage: number;
  lookingFor: string;
  profileType: string;
  confirmedAttendance: boolean;
}

/** Button event interface for job/assignment cards */
interface CardButtonEvent {
  event: string;
  data: string | JobPosting;
}

@Component({
  selector: "app-company-profile",
  templateUrl: "./company-profile.component.html",
  styleUrls: ["./company-profile.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FontAwesomeModule,
    TranslateModule,
    NgbCarouselModule,
    NgbPaginationModule,
    FormlyModule,
    LoaderComponent,
    JobCardComponent,
    StudentCardComponent,
    SelectorAreaofinterestsComponent,
  ],
})
export class CompanyProfileComponent implements OnInit {
  // Dependency Injection via inject()
  private readonly destroyRef = inject(DestroyRef);
  private readonly formDialog = inject(FormDialogService);
  readonly global = inject(GlobalService);
  private readonly alertService = inject(AlertService);
  readonly route = inject(ActivatedRoute);
  readonly router = inject(Router);
  readonly modal = inject(ModalService);
  readonly locale = inject(LocaleService);
  readonly interestService = inject(InterestService);
  private readonly matchService = inject(MatchService);
  readonly videoService = inject(VideoService);
  readonly experiencedayService = inject(ExperiencedayService);
  readonly authenticationService = inject(AuthenticationService);
  readonly electionService = inject(ElectionService);
  private readonly apiElectionService = inject(ApiElectionService);
  private readonly meetDayService = inject(MeetDayService);
  private readonly apiCompanyService = inject(ApiCompanyService);
  private readonly studentProfileService = inject(StudentProfileService);
  private readonly translationService = inject(TranslationService);
  private readonly areaOfInterestService = inject(AreaOfInterestService);
  private readonly matchCompetencyService = inject(MatchCompetencyService);
  private readonly jobPostingService = inject(JobPostingService);

  awvlUrl = environment.awvlUrl;
  isDNAEnabled = APP_CONFIG.isDNAEnabled;

  minimumMatchPercentage =
    this.matchService.minimumMatchPercentageCompanyMatchtest;

  jobpostingHours = jobpostingHours;

  avatarPlaceholder = companyprofilePlaceholder.avatarPlaceholder;
  avatarAccountPlaceholder = companyprofilePlaceholder.avatarAccountPlaceholder;

  RoleTypes = RoleTypes;

  // State signals
  readonly isLoading = signal(false);
  readonly errors = signal<Record<string, boolean>>({});

  // Icons
  faSearch = faSearch;
  faMapMarkerAlt = faMapMarkerAlt;
  faFacebookF = faFacebookF;
  faLinkedinIn = faLinkedinIn;
  faXTwitter = faXTwitter;
  faLink = faLink;
  faEdit = faEdit;
  faTimes = faTimes;
  faPlus = faPlus;
  faSave = faSave;
  faChevronUp = faChevronUp;
  faChevronDown = faChevronDown;
  faCalendar = faCalendar;
  faEye = faEye;
  faDna = faDna;
  faEnvelope = faEnvelope;
  faPhone = faPhone;
  faInfoCircle = faInfoCircle;
  faExternalLink = faExternalLink;
  faCheck = faCheck;
  faUndo = faUndo;
  faLanguage = faLanguage;

  // Translation state
  isTranslating = signal<boolean>(false);
  currentTranslatingField = signal<string>("");

  // Formly story form configuration
  storyForm = new FormGroup({});
  storyFields: FormlyFieldConfig[] = [
    {
      key: "description",
      type: "ckeditor-translatable",
      props: {
        label: "About us",
        fieldBaseName: "description",
        sourceLanguage: "nl",
        showTranslateButton: true,
        editorClass: "editor_xl",
      },
    },
    {
      key: "uniqueText",
      type: "ckeditor-translatable",
      props: {
        label: "What makes us so unique?",
        fieldBaseName: "uniqueText",
        sourceLanguage: "nl",
        showTranslateButton: true,
        editorClass: "editor_xl",
      },
    },
    {
      key: "opportunitiesText",
      type: "ckeditor-translatable",
      props: {
        label: "Career possibilities",
        fieldBaseName: "opportunitiesText",
        sourceLanguage: "nl",
        showTranslateButton: true,
        editorClass: "editor_xl",
      },
    },
  ];

  // Account state signals
  readonly currentAccount = signal<Account | null>(null);
  readonly isCompanyElectionAdmin = signal<boolean>(false);

  public Editor = ClassicEditor;
  public editorConfig: EditorConfig = {
    licenseKey: "GPL",
    plugins: [
      Heading,
      Link,
      Bold,
      Table,
      TableToolbar,
      Italic,
      List,
      BlockQuote,
    ],
    language: this.locale.getCurrentLanguage(),
    toolbar: [
      "heading",
      "|",
      "inserttable",
      "|",
      "bold",
      "italic",
      "link",
      "bulletedList",
      "numberedList",
      "blockQuote",
    ],
    heading: {
      options: [
        {
          model: "paragraph",
          title: "Paragraph",
          class: "ck-heading_paragraph",
        },
        {
          model: "heading1",
          view: "h1",
          title: "Heading 1",
          class: "ck-heading_heading1",
        },
        {
          model: "heading2",
          view: "h2",
          title: "Heading 2",
          class: "ck-heading_heading2",
        },
        {
          model: "heading3",
          view: "h3",
          title: "Heading 3",
          class: "ck-heading_heading3",
        },
        {
          model: "heading4",
          view: "h4",
          title: "Heading 4",
          class: "ck-heading_heading4",
        },
        {
          model: "heading5",
          view: "h5",
          title: "Heading 5",
          class: "ck-heading_heading5",
        },
        {
          model: "heading6",
          view: "h6",
          title: "Heading 6",
          class: "ck-heading_heading6",
        },
      ],
    },
  };

  readonly profile_id = signal("");
  // Signal so the async getCurrentCompanies() result renders the profile picker
  // immediately under OnPush (this branch sets no other signal to trigger CD).
  readonly selectableProfiles = signal<Company[]>([]);

  // Core entity signal
  readonly entity = signal<Company>({} as Company);

  companyPhotos: CompanyImageReference[] = [];
  companyVideos: Array<{ youtubeUri: string; youtubeImageUri: string }> = [];

  // Jobs state
  jobsData = signal<JobPosting[]>([]);
  jobsDataFiltered = signal<JobPosting[]>([]);
  jobsOrderby = signal<"name" | "date">("date");
  jobsOrder = signal<"asc" | "desc">("desc");
  jobsFiltersSearch = signal("");
  jobsFiltersTypes = signal<string[]>([]);

  // Assignments state
  assignmentsData = signal<JobPosting[]>([]);
  assignmentsDataFiltered = signal<JobPosting[]>([]);
  assignmentsOrderby = signal<"name" | "date">("date");
  assignmentsOrder = signal<"asc" | "desc">("desc");
  assignmentsFiltersSearch = signal("");
  assignmentsFiltersTypes = signal<string[]>([]);

  // Trademarks state
  trademarksData = signal<CompanyTrademark[]>([]);
  trademarksFiltersSearch = signal("");

  // Accounts state
  accountsData = signal<CompanyAccount[]>([]);

  // Experience days state
  experiencedaysLoading = signal(false);
  experiencedaysPageNumber = signal(1);
  experiencedaysPageSize = signal(15);
  experiencedaysTotalItems = signal(0);
  experiencedaysData = signal<ExperienceDay[]>([]);

  // Planned experience days state
  plannedExperiencedaysLoading = signal(false);
  plannedExperiencedaysPageNumber = signal(1);
  plannedExperiencedaysPageSize = signal(15);
  plannedExperiencedaysTotalItems = signal(0);
  plannedExperiencedaysData = signal<PlannedExperienceDay[]>([]);

  // Matches state
  matchesLoading = signal(false);
  matchesPageNumber = signal(1);
  matchesPageSize = signal(15);
  matchesTotalItems = signal(0);
  matchesData = signal<StudentProfile[]>([]);

  // Internationals state
  internationalsLoading = signal(false);
  internationalsPageNumber = signal(1);
  internationalsPageSize = signal(15);
  internationalsTotalItems = signal(0);
  internationalsData = signal<StudentProfile[]>([]);

  // Meetday scans state
  meetdayScansLoading = signal(false);

  // Static readonly options for sorting (replaces view object options)
  readonly orderByOptions = [
    { value: "name", label: "Name" },
    { value: "date", label: "Date" },
  ] as const;

  readonly orderOptions = [
    { value: "asc", label: "A-Z" },
    { value: "desc", label: "Z-A" },
  ] as const;

  public jobTypes: Array<{ value: string; label: string }> = [];

  public formChallengeday = {
    useChallengeday: false as boolean,
    minAmountStudents: "",
    maxAmountStudents: "",
    foreignStudents: "",
    internships: "",
    requirements: "",
    programme: "",
  };

  public dnaProfile: {
    language: string[];
    work_experience: string[];
    education: string[];
    sector: string[];
    personality: string[];
  } = {
    language: [],
    work_experience: [],
    education: [],
    sector: [],
    personality: [],
  };

  // General collection data to use
  areaOfInterests = signal<AreaOfInterest[]>([]);
  areaOfInterestsFiltered = computed(() =>
    this.locale.toFilterOptions(this.areaOfInterests(), "id", "name")
  );

  // Education level selector (Formly)
  readonly eduLevelsForm = new FormGroup({});
  readonly eduLevelFields: FormlyFieldConfig[] = [
    {
      key: "educationLevels",
      type: "education-level-selector",
      props: { excludedRegions: ["EU"] },
    },
  ];
  // Computed so the [model] reference is stable between CD cycles where the
  // entity hasn't changed. A plain getter would return a fresh object on every
  // access, making <formly-form> see [model] as "changed" every CD and resync
  // its internal model — that resync raced with formControl.setValue() in the
  // education-level-selector toggle and visually swallowed the click.
  readonly eduLevelsModel = computed(() => ({
    educationLevels: this.entity().educationLevels ?? [],
  }));
  onEduLevelsChange(m: Record<string, unknown>): void {
    this.updateEntityField(
      "educationLevels",
      m["educationLevels"] as Company["educationLevels"]
    );
  }

  updatingScanStatus = signal<string | null>(null);

  meetdayFilters = signal({
    selectedId: null as string | null,
  });
  meetdayScansData = signal<
    Array<{
      id: string;
      name: string;
      date: string;
      students: NormalizedMeetdayStudent[];
    }>
  >([]);
  meetdayOptions = computed(() => this.meetdayScansData());
  selectedMeetday = computed<{
    id: string;
    name: string;
    date: string;
    students: NormalizedMeetdayStudent[];
  } | null>(() => {
    const selectedId = this.meetdayFilters().selectedId;
    const meetdays = this.meetdayScansData();
    return meetdays.find((m) => m.id === selectedId) || meetdays[0] || null;
  });

  // Meetday scans search and filter
  meetdaySearchTerm = signal<string>("");
  meetdayScanFilter = signal<"all" | "scanned" | "notScanned">("all");

  // Statistics for meetday scans
  meetdayStats = computed(() => {
    const meetday = this.selectedMeetday();
    if (!meetday) return { total: 0, scanned: 0, notScanned: 0, percentage: 0 };

    const total = meetday.students.length;
    const scanned = meetday.students.filter(
      (s) => s.confirmedAttendance
    ).length;
    return {
      total,
      scanned,
      notScanned: total - scanned,
      percentage: total > 0 ? Math.round((scanned / total) * 100) : 0,
    };
  });

  // Filtered students for meetday scans
  filteredMeetdayStudents = computed(() => {
    const meetday = this.selectedMeetday();
    if (!meetday) return [];

    let students = meetday.students;

    const search = this.meetdaySearchTerm().toLowerCase();
    if (search) {
      students = students.filter((s) =>
        `${s.firstName} ${s.lastName}`.toLowerCase().includes(search)
      );
    }

    const filter = this.meetdayScanFilter();
    if (filter === "scanned") {
      students = students.filter((s) => s.confirmedAttendance);
    } else if (filter === "notScanned") {
      students = students.filter((s) => !s.confirmedAttendance);
    }

    return students;
  });

  // General match competency data to select for criterion
  matchCompetency = signal<MatchCompetency[]>([]);
  matchCompetencyCompanyCulture = computed(() =>
    this.matchCompetency().filter((c) => c.type === "CompanyCulture")
  );
  matchCompetencyPersonality = computed(() =>
    this.matchCompetency().filter((c) => c.type === "Personality")
  );

  // Match criterion signal
  readonly matchcriterion = signal<MatchCriterion>({
    companyCultureFactor: 0,
    personalityFactor: 0,
    areaOfInterestFactor: 0,
    companyCultureCompetencies: [],
    personalityCompetencies: [],
  });

  // Type-safe keys for competency arrays
  readonly companyCultureCompetencies = "companyCultureCompetencies" as const;
  readonly personalityCompetencies = "personalityCompetencies" as const;

  private readonly maxCompanyCultureCompetencies = 5;
  private readonly maxPersonalityCompetencies = 2;

  // Helper method to get competencies array by type
  private getCompetenciesArray(
    type: "companyCultureCompetencies" | "personalityCompetencies"
  ): MatchCriterionCompetency[] {
    return this.matchcriterion()[type] ?? [];
  }

  // Helper method to set competencies array by type
  private setCompetenciesArray(
    type: "companyCultureCompetencies" | "personalityCompetencies",
    value: MatchCriterionCompetency[]
  ): void {
    this.matchcriterion.update((criterion) => ({
      ...criterion,
      [type]: value,
    }));
  }

  // Elections signal
  readonly elections = signal<Election[]>([]);

  // Active tab signals for signal-driven tab navigation
  activeTab = signal("story");
  activeMatchcriteriaTab = signal("matchtest");
  activeExperiencedayTab = signal("myexperiencedays");

  constructor() {
    // Subscribe to authentication profile changes
    this.authenticationService.profile$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((account) => {
        this.currentAccount.set(account ? { ...account } : null);
        this.isCompanyElectionAdmin.set(
          account?.roles?.includes(RoleTypes.BedrijfsVerkiezingsbeheerder) ??
            false
        );
      });
  }

  /**
   * Ng on init
   */
  ngOnInit(): void {
    this.route.paramMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params: ParamMap) => {
        const id: string = params.get("id") ?? "";

        // If ID is found, load the profile
        if (!empty(id)) {
          this.loadCompanyprofile(id);
        }
        // Or else load all company profiles related to account
        else {
          // Get current company to show editable profiles
          this.apiCompanyService
            .getCurrentCompanies()
            .pipe(
              takeUntilDestroyed(this.destroyRef),
              catchError(this.handleError("apiGetCompanyCurrent", false))
            )
            .subscribe((companyProfiles: Company[] | boolean) => {
              if (companyProfiles && Array.isArray(companyProfiles)) {
                // No profiles are found, redirect to 404
                if (companyProfiles.length === 0) {
                  this.router.navigateByUrl("/errors/404");
                }

                // If only 1 profile is found, auto redirect to the profile
                else if (companyProfiles.length === 1) {
                  const companyProfile = companyProfiles[0];
                  this.router.navigateByUrl(
                    "/company/profile/" + companyProfile.id
                  );
                }

                // If multiple profiles are found, show selector
                else if (companyProfiles.length > 1) {
                  this.selectableProfiles.set(companyProfiles);
                }
              } else {
                // if no profiles or error redirect to not found page
                this.router.navigateByUrl("/errors/404");
              }
            });
        }
      });
  }

  /**
   * Load a company profile
   *
   * @param id
   * @param reload
   */
  loadCompanyprofile(id: string, reload = false): void {
    this.isLoading.set(true);

    this.apiCompanyService
      .getCompany({ id })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        catchError(this.handleError("apiGetCompanyProfile", false))
      )
      .subscribe((companyProfile: Company | boolean) => {
        // Do something if profile is not found
        this.isLoading.set(false);

        if (companyProfile && typeof companyProfile === "object") {
          this.profile_id.set(id);
          this.entity.set({ ...companyProfile });

          // Parse image data for carousel
          this.companyVideos = [];
          this.companyPhotos = [];
          const entityValue = this.entity();
          if ((entityValue.companyImageReferences?.length ?? 0) > 0) {
            entityValue.companyImageReferences!.forEach(
              (image: CompanyImageReference) => {
                if (image.youtubeUri) {
                  this.companyVideos.push({
                    youtubeUri: image.youtubeUri,
                    youtubeImageUri: this.videoService.getYoutubeThumbnail(
                      image.youtubeUri
                    ),
                  });
                } else {
                  if (image.imageUri) {
                    this.companyPhotos.push(image);
                  }
                }
              }
            );

            this.companyPhotos.reverse();
            this.companyVideos.reverse();
          }

          // Load general data to use
          this.getMatchCompetency();

          // Get related collection data
          this.getProfileTrademarks(this.profile_id());
          this.getCompanyAccounts(this.profile_id());
          this.getCompanyJobPostings();
          this.getMatchcriterion(this.profile_id());

          // Load experience days
          this.getCompanyExperiencedays(this.profile_id());

          // Load planned experience days (paginated — explicitly pass page
          // settings so BE doesn't fall back to a hard-coded default page size)
          this.getCompanyPlannedExperiencedays(this.profile_id(), {
            PageNumber: this.plannedExperiencedaysPageNumber(),
            PageSize: this.plannedExperiencedaysPageSize(),
          });

          this.loadActiveElections();

          // Placeholder load for meetday scans
          this.loadCompanyMeetdayScans();
        }
      });

    // Load general collection data
    this.areaOfInterestService
      .getAreaOfInterests()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        catchError(this.handleError("getAreaOfInterests", false))
      )
      .subscribe((result) => {
        if (result && typeof result !== "boolean") {
          this.areaOfInterests.set(result.data ?? []);
        }
      });
  }

  /**
   * Get company jobs
   */
  getCompanyJobPostings(): void {
    const entityValue = this.entity();
    this.jobPostingService
      .getJobPostingsByCompany({ companyId: entityValue.id! })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        if (result?.data) {
          const jobs = result.data.filter(
            (item: JobPosting) => item.type !== jobpostingTypes.Assignment
          );
          this.jobsData.set([...jobs]);
          this.jobsDataFiltered.set([...jobs]);

          // Add correct assignments job posting types
          const assignments = result.data.filter(
            (item: JobPosting) => item.type === jobpostingTypes.Assignment
          );
          this.assignmentsData.set([...assignments]);
          this.assignmentsDataFiltered.set([...assignments]);

          // Apply sorting on initial load
          this.applySortCompanyJobPostings();
          this.applySortCompanyAssignments();
        } else {
          this.jobsData.set([]);
          this.jobsDataFiltered.set([]);

          this.assignmentsData.set([]);
          this.assignmentsDataFiltered.set([]);
        }
      });
  }

  /**
   * Apply all filters on job postings of the company
   */
  applyFilterCompanyJobPostings(): void {
    const dataFiltered: JobPosting[] = [];
    const jobs = this.jobsData();
    const searchTerm = this.jobsFiltersSearch();
    const filterTypes = this.jobsFiltersTypes();

    if (jobs.length > 0) {
      for (const jobPosting of jobs) {
        let addJob = true;

        if (
          !empty(searchTerm) &&
          jobPosting.title?.toLowerCase().indexOf(searchTerm.toLowerCase()) ===
            -1
        ) {
          addJob = false;
        }

        // Exclude assignments
        if (jobPosting.type === jobpostingTypes.Assignment) {
          addJob = false;
        }

        if (
          !empty(filterTypes) &&
          !filterTypes.includes(jobPosting.type ?? "")
        ) {
          addJob = false;
        }

        if (addJob) {
          dataFiltered.push(jobPosting);
        }
      }
    }

    this.jobsDataFiltered.set([...dataFiltered]);
  }

  /**
   * Check if job posting filter type value already is set
   * @param type
   */
  existJobpostingType(type: string): boolean {
    return this.jobsFiltersTypes().includes(type);
  }

  /**
   * Toggle jobposting filter type value
   *
   * @param type
   */
  toggleJobpostingType(type: string): void {
    const currentTypes = this.jobsFiltersTypes();
    const index = currentTypes.indexOf(type);

    if (index === -1) {
      this.jobsFiltersTypes.set([...currentTypes, type]);
    } else {
      this.jobsFiltersTypes.set(currentTypes.filter((t) => t !== type));
    }

    this.applyFilterCompanyJobPostings();
  }

  /**
   * Apply sorting on job posting data
   */
  applySortCompanyJobPostings(): void {
    const filtered = this.jobsDataFiltered();
    if (filtered.length > 0) {
      const key = this.jobsOrderby() === "name" ? "title" : "createdOn";
      let sorted = sortArrayOnKey([...filtered], key);

      if (this.jobsOrder() === "desc") {
        sorted = sorted.reverse();
      }
      this.jobsDataFiltered.set(sorted);
    }
  }

  /**
   * Apply all filters on assignments of the company
   */
  applyFilterCompanyAssignments(): void {
    const dataFiltered: JobPosting[] = [];
    const assignments = this.assignmentsData();
    const searchTerm = this.assignmentsFiltersSearch();
    const filterTypes = this.assignmentsFiltersTypes();

    if (assignments.length > 0) {
      for (const jobPosting of assignments) {
        let addJob = true;

        if (
          !empty(searchTerm) &&
          jobPosting.title?.toLowerCase().indexOf(searchTerm.toLowerCase()) ===
            -1
        ) {
          addJob = false;
        }

        if (
          !empty(filterTypes) &&
          !filterTypes.includes(jobPosting.type ?? "")
        ) {
          addJob = false;
        }

        if (addJob) {
          dataFiltered.push(jobPosting);
        }
      }
    }

    this.assignmentsDataFiltered.set([...dataFiltered]);
  }

  /**
   * Apply sorting on assignment data
   */
  applySortCompanyAssignments(): void {
    const filtered = this.assignmentsDataFiltered();
    if (filtered.length > 0) {
      const key = this.assignmentsOrderby() === "name" ? "title" : "createdOn";
      let sorted = sortArrayOnKey([...filtered], key);

      if (this.assignmentsOrder() === "desc") {
        sorted = sorted.reverse();
      }
      this.assignmentsDataFiltered.set(sorted);
    }
  }

  /**
   * Get company experience days
   */
  getCompanyExperiencedays(
    $companyId: string,
    $queryParams: { PageNumber?: number; PageSize?: number } | null = null
  ): void {
    this.experiencedaysLoading.set(true);

    this.apiCompanyService
      .getCompanyExperienceDays({
        companyId: $companyId,
        PageNumber: $queryParams?.PageNumber,
        PageSize: $queryParams?.PageSize,
      })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        catchError(this.handleError("getCompanyExperienceDays", false))
      )
      .subscribe((result) => {
        this.experiencedaysLoading.set(false);

        if (result && typeof result !== "boolean" && result.data) {
          this.experiencedaysData.set(result.data);
          this.experiencedaysTotalItems.set(result.totalItems ?? 0);
        }
      });
  }

  /**
   * Get company planned experience days
   */
  getCompanyPlannedExperiencedays(
    $companyId: string,
    $queryParams: {
      ExperienceDayId?: string;
      PendingOnly?: boolean;
      ConfirmedOnly?: boolean;
      PageNumber?: number;
      PageSize?: number;
    } | null = null
  ): void {
    this.plannedExperiencedaysLoading.set(true);

    this.apiCompanyService
      .getCompanyPlannedExperienceDays({
        companyId: $companyId,
        ExperienceDayId: $queryParams?.ExperienceDayId,
        PendingOnly: $queryParams?.PendingOnly,
        ConfirmedOnly: $queryParams?.ConfirmedOnly,
        PageNumber: $queryParams?.PageNumber,
        PageSize: $queryParams?.PageSize,
      })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        catchError(this.handleError("getCompanyPlannedExperienceDays", false))
      )
      .subscribe((result) => {
        this.plannedExperiencedaysLoading.set(false);

        if (result && typeof result !== "boolean" && result.data) {
          this.plannedExperiencedaysData.set(result.data);
          this.plannedExperiencedaysTotalItems.set(result.totalItems ?? 0);
        }
      });
  }

  /**
   * Toggle planned experience day attendancy
   *
   * @param plannedexperienceday
   */
  togglePlannedExperiencedayAttendancy(
    plannedexperienceday: PlannedExperienceDay
  ): void {
    const params = { ...plannedexperienceday };
    params.hasAttended = !params.hasAttended;

    // Save data
    this.apiCompanyService
      .updateCompanyPlannedExperienceDay({
        companyId: params.companyId!,
        id: params.id!,
        body: params,
      })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        catchError(this.handleError("updateCompanyPlannedExperienceDay", false))
      )
      .subscribe((response) => {
        if (response !== false) {
          // Success - data updated
        }
      });
  }

  /**
   * Add a new job posting
   */
  addJobposting(): void {
    this.formDialog
      .open<JobPostingModel>(() =>
        buildJobPostingDefinition({
          profile: this.entity(),
          entity: undefined,
          isAdminMode: false,
        })
      )
      .subscribe((model) => {
        if (!model) return;
        saveJobPosting(this.jobPostingService, this.alertService, model)
          .pipe(catchError(() => of(null)))
          .subscribe((saved) => {
            if (saved) this.getCompanyJobPostings();
          });
      });
  }

  /**
   * Update single job posting
   *
   * @param jobposting
   */
  updateJobPosting(jobposting: JobPosting): void {
    this.formDialog
      .open<JobPostingModel>(() =>
        buildJobPostingDefinition({
          profile: this.entity(),
          entity: jobposting,
          isAdminMode: false,
        })
      )
      .subscribe((model) => {
        if (!model) return;
        saveJobPosting(this.jobPostingService, this.alertService, model)
          .pipe(catchError(() => of(null)))
          .subscribe((saved) => {
            if (saved) this.getCompanyJobPostings();
          });
      });
  }

  /**
   * Delete single job posting
   *
   * @param id
   */
  deleteJobPosting(id: string): void {
    this.modal
      .Confirm("Delete", "Are you sure you want to delete this?")
      .then((confirm) => {
        if (confirm === true) {
          this.jobPostingService
            .deleteJobPosting({ id })
            .pipe(
              takeUntilDestroyed(this.destroyRef),
              catchError(this.handleError("deleteJobPosting", false))
            )
            .subscribe((result) => {
              if (result !== false) {
                this.alertService.success(alertMessages.successDataRemoved);
                this.getCompanyJobPostings();
              }
            });
        }
      })
      .catch(() => {});
  }

  /**
   * Add a new assignment ( job posting type )
   */
  addAssignment(): void {
    const modalOptions = {
      size: "xl",
      scrollable: true,
      backdrop: "static",
    };

    const entityValue = this.entity();
    const data = {
      profile: entityValue,
      entity: {
        id: "",
        companyId: "",
        company: {
          id: "",
          status: "",
          name: "",
          registrationNumber: "",
          visitAddress: {
            street: "",
            number: "",
            numberSuffix: "",
            postalCode: "",
            city: "",
            country: "",
            latitude: "",
            longitude: "",
          },
          phoneNumber: "",
          address_city: "",
          description: "",
          descriptionEn: "",
          descriptionDe: "",
          descriptionFr: "",
          descriptionPt: "",
          uniqueText: "",
          uniqueTextEn: "",
          uniqueTextDe: "",
          uniqueTextFr: "",
          opportunitiesText: "",
          opportunitiesTextEn: "",
          opportunitiesTextDe: "",
          opportunitiesTextFr: "",
          opportunitiesTextPt: "",
          sectorId: "",
          sectorName: "",
          numberOfEmployees: "",
          websiteUri: "",
          twitterUri: "",
          facebookUri: "",
          linkedInUri: "",
          instagramUri: "",
          googleUri: "",
          avatarUri: "",
          coverPhotoUri: "",
          isCurrentUserFavorite: false,
        },
        trademarkId: "",
        trademark: {
          id: "",
          name: "",
          description: "",
          avatarUri: "",
          coverPhotoUri: "",
        },
        contactPersonId: "",
        contactPerson: {
          id: "",
          emailAddress: "",
          firstName: "",
          lastName: "",
          phoneNumber: "",
        },
        isCurrentUserFavorite: false,
        title: "",
        location: "",
        description: "",
        address: {
          street: !empty(entityValue.visitAddress?.street)
            ? entityValue.visitAddress?.street
            : "",
          number: !empty(entityValue.visitAddress?.number)
            ? entityValue.visitAddress?.number
            : "",
          numberSuffix: !empty(entityValue.visitAddress?.numberSuffix)
            ? entityValue.visitAddress?.numberSuffix
            : "",
          postalCode: !empty(entityValue.visitAddress?.postalCode)
            ? entityValue.visitAddress?.postalCode
            : "",
          city: !empty(entityValue.visitAddress?.city)
            ? entityValue.visitAddress?.city
            : "",
          country: !empty(entityValue.visitAddress?.country)
            ? entityValue.visitAddress?.country
            : "",
        },
        requirements: "",
        termsOfEmployment: "",
        additionalInfo: "",
        immediatelyAvailable: false,
        startDate: null,
        deadline: null,
        hours: this.jobpostingHours.Fulltime, // set default to fulltime
        hoursPerWeek: 0,
        isExperienceDesired: false,
        externalReferenceUri: "",
        status: "",
        type: jobpostingTypes.Assignment, // Use fixed type for assignment
        areaOfInterests: [] as AreaOfInterest[],
        educationLevels: [] as EducationLevel[],
        documents: [] as unknown[],
        related_jobs: [] as unknown[],
      },
    };

    const modalRefLoader = this.modal.modalLoaderRef();

    modalRefLoader.shown.subscribe(() => {
      const modalRef = this.modal.modalComponentRef(
        ModalCompanyProfileAssignmentComponent,
        "",
        "",
        data,
        [],
        modalOptions
      );

      modalRef.shown.subscribe(() => {
        modalRefLoader.close(true);
      });

      modalRef.result.then((result) => {
        if (result === true) {
          this.getCompanyJobPostings();
        }
      });
    });
  }

  /**
   * Update single job posting
   *
   * @param jobposting
   */
  updateAssignment(jobposting: JobPosting): void {
    const modalOptions = {
      size: "xl",
      scrollable: true,
      backdrop: "static",
    };

    const data = {
      profile: this.entity(),
      entity: jobposting,
    };

    const modalRefLoader = this.modal.modalLoaderRef();

    modalRefLoader.shown.subscribe(() => {
      const modalRef = this.modal.modalComponentRef(
        ModalCompanyProfileAssignmentComponent,
        "",
        "",
        data,
        [],
        modalOptions
      );

      modalRef.shown.subscribe(() => {
        modalRefLoader.close(true);
      });

      modalRef.result.then((result) => {
        if (result === true) {
          this.getCompanyJobPostings();
        }
      });
    });
  }

  /**
   * Show matches of a single job posting
   *
   * @param id
   */
  matchesJobPosting(id: string, title = "Job matches"): void {
    const modalOptions = {
      size: "xl",
      scrollable: true,
      backdrop: "static",
    };

    const data = {
      jobpostingId: id,
    };

    this.modal
      .Modal(
        ModalCompanyProfileJobmatchesComponent,
        title,
        "",
        data,
        [],
        modalOptions
      )
      .then(() => {});
  }

  /**
   * Add a new experience day
   */
  addExperienceday(): void {
    const modalOptions = {
      size: "xl",
      scrollable: true,
      backdrop: "static",
    };

    const entityValue = this.entity();
    const data = {
      profile: entityValue,
      entity: {
        id: "",
        companyId: entityValue.id,
        title: "",
        description: "",
        minStudents: 0,
        maxStudents: 0,
        possibleDates: [] as string[],
      },
    };

    this.modal
      .Modal(
        ModalCompanyProfileExperiencedayComponent,
        "",
        "",
        data,
        [],
        modalOptions
      )
      .then((result) => {
        if (result === true) {
          this.getCompanyExperiencedays(this.profile_id());
        }
      });
  }

  /**
   * Update experience day
   * @param experienceday
   */
  updateExperienceday(experienceday: ExperienceDay): void {
    const modalOptions = {
      size: "xl",
      scrollable: true,
      backdrop: "static",
    };

    const data = {
      profile: this.entity(),
      entity: experienceday,
    };

    this.modal
      .Modal(
        ModalCompanyProfileExperiencedayComponent,
        "",
        "",
        data,
        [],
        modalOptions
      )
      .then((result) => {
        if (result === true) {
          this.getCompanyExperiencedays(this.profile_id());
        }
      });
  }

  /**
   * Delete experience day of company
   * @param $id
   */
  deleteExperienceday($companyId: string, $id: string): void {
    this.modal
      .Confirm("Delete", "Are you sure you want to delete this?")
      .then((confirm) => {
        if (confirm) {
          this.apiCompanyService
            .deleteCompanyExperienceDay({
              companyId: $companyId,
              id: $id,
            })
            .pipe(
              takeUntilDestroyed(this.destroyRef),
              catchError(this.handleError("deleteCompanyExperienceDay", false))
            )
            .subscribe((result) => {
              if (result !== false) {
                this.alertService.success(alertMessages.successDataRemoved);

                this.getCompanyExperiencedays($companyId);
              }
            });
        }
      })
      .catch(() => {});
  }

  /**
   * Get all trademarks of company profile
   *
   * @param profile_id
   */
  getProfileTrademarks(profile_id: string): void {
    this.apiCompanyService
      .getCompanyTrademarks({ companyId: profile_id })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((trademarks) => {
        if (trademarks) {
          this.trademarksData.set([...trademarks]);
        } else {
          this.trademarksData.set([]);
        }
      });
  }

  /**
   * Get company accounts of company profile
   *
   * @param profile_id
   */
  getCompanyAccounts(profile_id: string): void {
    this.apiCompanyService
      .getCompanyAccounts({ companyId: profile_id })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((accounts) => {
        if (accounts) {
          this.accountsData.set([...accounts]);
        } else {
          this.accountsData.set([]);
        }
      });
  }

  /**
   * Add a single trademark
   */
  addTrademark(): void {
    const modalOptions = {
      size: "xl",
      scrollable: true,
      backdrop: "static",
    };

    const data = {
      profile: this.entity(),
      entity: {
        name: "",
        description: "",
      },
    };

    this.modal
      .Modal(
        ModalCompanyProfileTradenameComponent,
        "",
        "",
        data,
        [],
        modalOptions
      )
      .then((result) => {
        if (result === true) {
          this.getProfileTrademarks(this.profile_id());
        }
      });
  }

  /**
   * Update a single trademark
   *
   * @param trademark | values
   */
  updateTrademark(trademark: CompanyTrademark): void {
    const modalOptions = {
      size: "xl",
      scrollable: true,
      backdrop: "static",
    };

    const data = {
      profile: this.entity(),
      entity: trademark,
    };

    this.modal
      .Modal(
        ModalCompanyProfileTradenameComponent,
        "",
        "",
        data,
        [],
        modalOptions
      )
      .then((result) => {
        if (result === true) {
          this.getProfileTrademarks(this.profile_id());
        }
      });
  }

  /**
   * Delete a single trademark
   *
   * @param id
   */
  deleteTrademark(id: string): void {
    this.modal
      .Confirm("Delete", "Are you sure you want to delete this?")
      .then((confirm) => {
        if (confirm === true) {
          this.apiCompanyService
            .deleteCompanyTrademark({ companyId: this.profile_id(), id })
            .pipe(
              takeUntilDestroyed(this.destroyRef),
              catchError(this.handleError("apiDeleteTrademark", false))
            )
            .subscribe((result) => {
              if (result !== false) {
                this.alertService.success(alertMessages.successDataRemoved);
                this.getProfileTrademarks(this.profile_id());
              }
            });
        }
      })
      .catch(() => {});
  }

  /**
   * Edit the avatar of the company profile
   */
  editAvatar(): void {
    const modalOptions = {
      size: "xl",
      backdrop: "static",
    };

    const data = { ...this.entity() };

    this.modal
      .Modal(ModalCompanyProfileAvatarComponent, "", "", data, [], modalOptions)
      .then((result) => {
        if (result === true) {
          this.loadCompanyprofile(this.profile_id(), true);
        }
      })
      .catch(() => {});
  }

  /**
   * Edit the avatar of the company profile
   */
  editCover(): void {
    const modalOptions = {
      size: "xl",
      backdrop: "static",
    };

    const data = { ...this.entity() };

    this.modal
      .Modal(ModalCompanyProfileCoverComponent, "", "", data, [], modalOptions)
      .then((result) => {
        if (result === true) {
          this.loadCompanyprofile(this.profile_id(), true);
        }
      })
      .catch(() => {});
  }

  /**
   * Edit photos
   */
  editPhotos(): void {
    const data = {
      profile: this.entity(),
      entity: {
        title: "",
        decription: "",
      },
    };

    const modalOptions = { size: "xl", scrollable: true, backdrop: "static" };

    this.modal
      .Modal(ModalCompanyProfilePhotoComponent, "", "", data, [], modalOptions)
      .then((result) => {
        if (result === true) {
          this.loadCompanyprofile(this.profile_id(), true);
        }
      });
  }

  /**
   * Edit videos
   */
  editVideos(): void {
    const data = {
      profile: this.entity(),
      entity: {
        title: "",
        decription: "",
      },
    };

    const modalOptions = { size: "xl", scrollable: true, backdrop: "static" };

    this.modal
      .Modal(ModalCompanyProfileVideoComponent, "", "", data, [], modalOptions)
      .then((result) => {
        if (result === true) {
          this.loadCompanyprofile(this.profile_id(), true);
        }
      });
  }

  /**
   * Update a field on the entity signal
   */
  updateEntityField<K extends keyof Company>(
    field: K,
    value: Company[K]
  ): void {
    this.entity.update((e) => ({ ...e, [field]: value }));
  }

  /**
   * Update a field on the matchcriterion signal
   */
  updateMatchcriterionField<K extends keyof MatchCriterion>(
    field: K,
    value: MatchCriterion[K]
  ): void {
    this.matchcriterion.update((c) => ({ ...c, [field]: value }));
  }

  /**
   * Update a field on the entity's visitAddress
   */
  updateEntityVisitAddress(
    field: keyof NonNullable<Company["visitAddress"]>,
    value: string
  ): void {
    this.entity.update((e) => ({
      ...e,
      visitAddress: { ...e.visitAddress!, [field]: value },
    }));
  }

  /**
   * Update entity sector with both id and name
   */
  updateEntitySector(sectorId: string | undefined): void {
    this.entity.update((e) => ({
      ...e,
      sectorId: sectorId,
      sectorName: this.interestService.getAreaOfInterestName(
        sectorId ?? null,
        this.areaOfInterests()
      ),
    }));
  }

  /**
   * Apply automatic correction of values when a factor number is changed
   *
   * @param $factor
   */
  onFactorChange($factor: string): void {
    const criterion = this.matchcriterion();
    const companyCulture = criterion.companyCultureFactor ?? 0;
    const personality = criterion.personalityFactor ?? 0;
    const areaOfInterest = criterion.areaOfInterestFactor ?? 0;
    const totalFactor = companyCulture + personality + areaOfInterest;

    if (totalFactor <= 100) return;

    switch ($factor) {
      case "companyCultureFactor":
        this.matchcriterion.update((c) => ({
          ...c,
          companyCultureFactor: 100 - (areaOfInterest + personality),
        }));
        break;

      case "personalityFactor":
        this.matchcriterion.update((c) => ({
          ...c,
          personalityFactor: 100 - (companyCulture + areaOfInterest),
        }));
        break;

      case "areaOfInterestFactor":
        this.matchcriterion.update((c) => ({
          ...c,
          areaOfInterestFactor: 100 - (companyCulture + personality),
        }));
        break;
    }
  }

  /**
   * Get all match compentencies
   */
  getMatchCompetency(): void {
    this.matchCompetencyService
      .getMatchCompetencies()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        catchError(this.handleError("getMatchCompetencies", false))
      )
      .subscribe((response) => {
        if (response && typeof response !== "boolean" && response.data) {
          this.matchCompetency.set([...response.data]);
          // matchCompetencyCompanyCulture and matchCompetencyPersonality are now computed signals
        }
      });
  }

  /**
   * Get match competencies by type
   *
   * Uses matchCompetency signal to collect
   *
   * @param $type
   */
  getMatchCompetenciesByType($type: string): MatchCompetency[] {
    return this.matchCompetency().filter((comp) => comp.type === $type);
  }

  /**
   * Get match criterion data of company profile
   *
   * @param $profile_id
   */
  getMatchcriterion($profile_id: string): void {
    this.apiCompanyService
      .getCompanyMatchCriterion({ companyId: $profile_id })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        catchError(this.handleError("apiGetMatchcriterion", null))
      )
      .subscribe((response) => {
        if (response && typeof response === "object") {
          this.matchcriterion.set({ ...response });
        }
      });
  }

  /**
   * Get a single competency item by id
   *
   * @param competenceId
   */
  getCompetencyItem(competenceId: string): MatchCompetency | null {
    return (
      this.matchCompetency().find(
        (competency) => competency.id === competenceId
      ) ?? null
    );
  }

  /**
   * Toggle selected match criterion competency
   *
   * @param competenceId
   * @param type 'companyCultureCompetencies' | 'personalityCompetencies'
   */
  toggleMatchtestCompetence(
    competenceId: string,
    type: "companyCultureCompetencies" | "personalityCompetencies"
  ): void {
    const competencies = this.getCompetenciesArray(type);

    if (!this.hasMatchtestCompetenceValue(competenceId, type)) {
      // Check max limits
      if (
        type === "companyCultureCompetencies" &&
        competencies.length >= this.maxCompanyCultureCompetencies
      ) {
        return;
      }
      if (
        type === "personalityCompetencies" &&
        competencies.length >= this.maxPersonalityCompetencies
      ) {
        return;
      }

      const competencyItem = this.getCompetencyItem(competenceId);
      if (competencyItem) {
        const newCompetencies = [
          ...competencies,
          {
            matchCompetencyId: competencyItem.id!,
            name: competencyItem.name,
            description: competencyItem.description,
            sort: competencies.length + 1,
          },
        ];
        this.setCompetenciesArray(type, newCompetencies);
      }
    } else {
      // Remove item
      const updatedCompetencies = competencies.filter(
        (comp) => comp.matchCompetencyId !== competenceId
      );
      this.setCompetenciesArray(type, updatedCompetencies);
    }
  }

  /**
   * Determine if a match competency of a specific type is set or not
   *
   * @param $competence_id
   * @param $type 'companyCultureCompetencies' | 'personalityCompetencies'
   */
  hasMatchtestCompetenceValue(
    competenceId: string,
    type: "companyCultureCompetencies" | "personalityCompetencies"
  ): boolean {
    if (empty(type)) return false;
    const competencies = this.getCompetenciesArray(type);
    return competencies.some((comp) => comp.matchCompetencyId === competenceId);
  }

  /**
   * Sort the array of match criterion based on sort value
   *
   * @param type
   */
  sortMatchcriterionCompetencies(
    type: "companyCultureCompetencies" | "personalityCompetencies"
  ): void {
    const competencies = [...this.getCompetenciesArray(type)];
    competencies.sort((a, b) => a.sort - b.sort);
    this.setCompetenciesArray(type, competencies);
  }

  /**
   * Move a match criterion competency up in sorting
   *
   * @param key
   * @param type
   */
  moveMatchcriterionCompetencyUp(
    key: number,
    type: "companyCultureCompetencies" | "personalityCompetencies"
  ): void {
    if (key > 0) {
      const competencies = [...this.getCompetenciesArray(type)];
      const currentSort = competencies[key].sort;
      competencies[key] = {
        ...competencies[key],
        sort: competencies[key - 1].sort,
      };
      competencies[key - 1] = { ...competencies[key - 1], sort: currentSort };
      this.setCompetenciesArray(type, competencies);
      this.sortMatchcriterionCompetencies(type);
    }
  }

  /**
   * Move a match criterion competency down in sorting
   *
   * @param key
   * @param type
   */
  moveMatchcriterionCompetencyDown(
    key: number,
    type: "companyCultureCompetencies" | "personalityCompetencies"
  ): void {
    const competencies = [...this.getCompetenciesArray(type)];
    if (key < competencies.length - 1) {
      const currentSort = competencies[key].sort;
      competencies[key] = {
        ...competencies[key],
        sort: competencies[key + 1].sort,
      };
      competencies[key + 1] = { ...competencies[key + 1], sort: currentSort };
      this.setCompetenciesArray(type, competencies);
      this.sortMatchcriterionCompetencies(type);
    }
  }

  /**
   * Save all match criteria for matching
   */
  updateMatchcriteria(): void {
    const entityValue = this.entity();
    const criterionValue = this.matchcriterion();

    const matchUpdatePromises = {
      // match criterion data promise
      matchcriterionPromise: new Promise((resolve, reject) => {
        this.apiCompanyService
          .updateCompanyMatchCriterion({
            companyId: this.profile_id(),
            body: criterionValue,
          })
          .pipe(
            takeUntilDestroyed(this.destroyRef),
            catchError(this.handleError("apiUpdateMatchcriterion", false))
          )
          .subscribe((result) => {
            if (result !== false) resolve(true);
            else reject(false);
          });
      }),
      // Match area of interest promise
      matchAreaOfInterestsPromise: new Promise((resolve, reject) => {
        this.apiCompanyService
          .setCompanyAreaOfInterest({
            companyId: this.profile_id(),
            body: entityValue.areaOfInterests ?? undefined,
          })
          .pipe(
            takeUntilDestroyed(this.destroyRef),
            catchError(this.handleError("apiUpdateAreaOfInterests", false))
          )
          .subscribe((result) => {
            if (result !== false) resolve(true);
            else reject(false);
          });
      }),
      // company profile
      companyProfile: new Promise((resolve, reject) => {
        this.apiCompanyService
          .updateCompany({
            id: this.profile_id(),
            body: entityValue as Parameters<
              typeof this.apiCompanyService.updateCompany
            >[0]["body"],
          })
          .pipe(
            takeUntilDestroyed(this.destroyRef),
            catchError(this.handleError("apiUpdateCompanyprofile", false))
          )
          .subscribe((result) => {
            if (result !== false) resolve(true);
            else reject(false);
          });
      }),
    };
    // Handler if all promises are resolved / rejected
    Promise.all([
      matchUpdatePromises.matchcriterionPromise,
      matchUpdatePromises.matchAreaOfInterestsPromise,
      matchUpdatePromises.companyProfile,
    ]).then((values) => {
      // Check values and then close or warn
      if (values[0] === true && values[1] === true) {
        this.alertService.success(alertMessages.successDataSaved);

        // Automatically open matches
        this.activeTab.set("matchcriteria");
        this.activeMatchcriteriaTab.set("matches");

        // Scroll back to top automatically when route is activated
        window.scrollTo(0, 0);
      } else {
        this.alertService.errorWithReport(
          new Error("matchcriteria save failed"),
          "companyProfile:saveMatchCriteria"
        );
      }
    });
  }

  /**
   * Update company profile
   */
  UpdateCompanyProfile(): void {
    this.errors.set({});
    const entityValue = this.entity();
    const newErrors: Record<string, boolean> = {};

    if (empty(entityValue.visitAddress?.street)) {
      newErrors["street"] = true;
    }

    if (empty(entityValue.visitAddress?.number)) {
      newErrors["number"] = true;
    }

    if (empty(entityValue.visitAddress?.city)) {
      newErrors["city"] = true;
    }

    if (empty(entityValue.visitAddress?.postalCode)) {
      newErrors["postalCode"] = true;
    }

    if (empty(entityValue.visitAddress?.country)) {
      newErrors["country"] = true;
    }

    if (Object.keys(newErrors).length > 0) {
      this.errors.set(newErrors);
      const element = document.getElementById("validation-errors");
      if (element) {
        window.scrollTo(0, element.offsetTop - 0);
      }
      return;
    }

    this.apiCompanyService
      .updateCompany({
        id: entityValue.id!,
        body: entityValue as Parameters<
          typeof this.apiCompanyService.updateCompany
        >[0]["body"],
      })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        catchError(this.handleError("apiUpdateCompanyprofile", false))
      )
      .subscribe((result) => {
        if (result !== false) {
          this.alertService.success(alertMessages.successDataSaved);
        }
      });
  }

  /**
   * Add a company account
   */
  addCompanyAccount(): void {
    const modalOptions = {
      size: "xl",
      scrollable: true,
      backdrop: "static",
    };

    const data = {
      profile: this.entity(),
      entity: {
        emailAddress: "",
        firstName: "",
        lastName: "",
      },
    };

    this.modal
      .Modal(
        ModalCompanyProfileAccountComponent,
        "",
        "",
        data,
        [],
        modalOptions
      )
      .then((result) => {
        if (result === true) {
          this.getCompanyAccounts(this.profile_id());
        }
      });
  }

  /**
   * Update a company account
   *
   * @param $account
   */
  updateCompanyAccount($account: CompanyAccount): void {
    const modalOptions = {
      size: "xl",
      scrollable: true,
      backdrop: "static",
    };

    const data = {
      profile: this.entity(),
      entity: $account,
    };

    this.modal
      .Modal(
        ModalCompanyProfileAccountComponent,
        "",
        "",
        data,
        [],
        modalOptions
      )
      .then((result) => {
        if (result === true) {
          this.getCompanyAccounts(this.profile_id());
        }
      });
  }

  /**
   * Delete a company account
   *
   * @param $profile_id
   * @param $accountId
   */
  deleteCompanyAccount($profile_id: string, $accountId: string): void {
    this.modal
      .Confirm("Delete", "Are you sure you want to delete this?")
      .then((confirm) => {
        if (confirm === true) {
          // Post all company accounts without current one
          this.apiCompanyService
            .getCompanyAccounts({ companyId: $profile_id })
            .pipe(
              takeUntilDestroyed(this.destroyRef),
              catchError(this.handleError("apiGetCompanyAccounts", []))
            )
            .subscribe((companyAccounts) => {
              if (companyAccounts && Array.isArray(companyAccounts)) {
                const newAccounts = companyAccounts.filter(
                  (account: CompanyAccount) => account.accountId !== $accountId
                );

                this.apiCompanyService
                  .setCompanyAccounts({
                    companyId: $profile_id,
                    body: newAccounts,
                  })
                  .pipe(takeUntilDestroyed(this.destroyRef))
                  .subscribe(() => {
                    this.accountsData.set([...newAccounts]);
                    this.alertService.success(alertMessages.successDataRemoved);
                  });
              }
            });
        }
      })
      .catch(() => {});
  }

  /**
   * Handle job buttons events
   *
   * @param $event
   */
  handleJobButtonEvent($event: CardButtonEvent): void {
    if ($event.event) {
      switch ($event.event) {
        case "matches":
          this.matchesJobPosting($event.data as string);
          break;

        case "delete":
          this.deleteJobPosting($event.data as string);
          break;

        case "edit":
          this.updateJobPosting($event.data as JobPosting);
          break;
      }
    }
  }

  /**
   * Handle job buttons events
   *
   * @param $event
   */
  handleAssignmentButtonEvent($event: CardButtonEvent): void {
    if ($event.event) {
      switch ($event.event) {
        case "matches":
          this.matchesJobPosting($event.data as string, "Assignment matches");
          break;

        case "delete":
          this.deleteJobPosting($event.data as string);
          break;

        case "edit":
          this.updateAssignment($event.data as JobPosting);
          break;
      }
    }
  }

  /**
   * Get matches. Sorts by `callforopportunity` DESC so students with an
   * active oproep bubble to the top — the BE handles this directly on
   * `GetStudentProfiles` so we no longer need a parallel call to
   * `/matchesforcompany/{companyId}`. @see #18092
   */
  getMatches(): void {
    this.matchesLoading.set(true);

    this.studentProfileService
      .getStudentProfiles({
        PageNumber: this.matchesPageNumber(),
        PageSize: this.matchesPageSize(),
        MinimumMatchPercentage: this.minimumMatchPercentage,
        SortField: "callforopportunity",
        SortType: SortType.Descending,
      } as any)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        catchError(this.handleError("getStudentProfiles", false))
      )
      .subscribe((result) => {
        this.matchesLoading.set(false);

        if (result && typeof result !== "boolean" && result.data) {
          this.matchesData.set([...result.data]);
          this.matchesTotalItems.set(result.totalItems ?? 0);
        } else {
          this.matchesData.set([]);
        }
      });
  }

  selectTab(tabId: string): void {
    this.activeTab.set(tabId);
  }

  showMatchesTab(): void {
    this.activeTab.set("matchcriteria");
    this.activeMatchcriteriaTab.set("matches");
    this.getMatches();
  }

  /**
   * Get international matches
   */
  getInternationalMatches(): void {
    this.internationalsLoading.set(true);

    this.studentProfileService
      .getStudentProfiles({
        PageNumber: this.internationalsPageNumber(),
        PageSize: this.internationalsPageSize(),
        MinimumMatchPercentage: this.minimumMatchPercentage,
        SortField: "currentUserMatchPercentage",
        SortType: SortType.Descending,
        TargetGroups: ["International"],
      } as any)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        catchError(this.handleError("getStudentProfiles", false))
      )
      .subscribe((result) => {
        this.internationalsLoading.set(false);

        if (result && typeof result !== "boolean" && result.data) {
          this.internationalsData.set([...result.data]);
          this.internationalsTotalItems.set(result.totalItems ?? 0);
        } else {
          this.internationalsData.set([]);
        }
      });
  }

  showInternationalsTab(): void {
    this.activeTab.set("matchcriteria");
    this.activeMatchcriteriaTab.set("internationals");
    this.getInternationalMatches();
  }

  loadActiveElections(): void {
    this.apiElectionService
      .getActiveElections()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response) => {
        this.elections.set([...(response ?? [])]);
      });
  }

  onMeetdaySelection(meetdayId: string | null): void {
    this.meetdayFilters.update(() => ({
      selectedId: meetdayId,
    }));

    // Reset search and filter when changing meetday
    this.meetdaySearchTerm.set("");
    this.meetdayScanFilter.set("all");

    // Load students for the selected meetday
    if (meetdayId && this.profile_id()) {
      this.loadStudentsForMeetday(meetdayId);
    }
  }

  private loadStudentsForMeetday(meetdayId: string): void {
    this.meetdayScansLoading.set(true);

    this.apiCompanyService
      .getCompanyConnectionsForMeetDay({
        id: this.profile_id(),
        meetDayId: meetdayId,
      })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        catchError(() => of([]))
      )
      .subscribe((students: MeetDayStudent[]) => {
        // Get student profile IDs that need to be fetched
        const studentProfileIds = (students || [])
          .filter((s) => s.studentProfileId && !s.anonymousMeetdayStudent)
          .map((s) => s.studentProfileId!);

        if (studentProfileIds.length === 0) {
          // Only anonymous students or no students, normalize and update
          this.updateMeetdayStudents(meetdayId, students, {});
          return;
        }

        // Fetch student profiles in parallel
        const profileRequests = studentProfileIds.map((id) =>
          this.studentProfileService
            .getStudentProfile({ id })
            .pipe(catchError(() => of(null)))
        );

        forkJoin(profileRequests)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: (profiles: (StudentProfile | null)[]) => {
              // Create a map of studentProfileId -> StudentProfile
              const profileMap: Record<string, StudentProfile> = {};
              profiles.forEach((profile, index) => {
                if (profile) {
                  profileMap[studentProfileIds[index]] = profile;
                }
              });
              this.updateMeetdayStudents(meetdayId, students, profileMap);
            },
            error: () => {
              this.updateMeetdayStudents(meetdayId, students, {});
            },
          });
      });
  }

  private updateMeetdayStudents(
    meetdayId: string,
    students: MeetDayStudent[],
    profileMap: Record<string, StudentProfile>
  ): void {
    const normalizedStudents = (students || []).map((student) => {
      const profile = student.studentProfileId
        ? profileMap[student.studentProfileId]
        : undefined;
      return this.normalizeMeetdayStudent(student, profile);
    });

    // Update the meetdayScansData with the students
    this.meetdayScansData.update((meetdays) =>
      meetdays.map((m) =>
        m.id === meetdayId ? { ...m, students: normalizedStudents } : m
      )
    );

    this.meetdayScansLoading.set(false);
  }

  loadCompanyMeetdayScans(): void {
    this.meetdayScansLoading.set(true);

    if (!this.profile_id()) {
      this.meetdayScansLoading.set(false);
      return;
    }

    this.meetDayService
      .getMeetDays({ PageNumber: 1, PageSize: 200 })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((response) => response.data || []),
        map((meetdays) =>
          meetdays.filter((meetday: MeetDay) =>
            (meetday.registeredCompanies || []).some(
              (company) => company.id === this.profile_id()
            )
          )
        ),
        catchError(() => {
          this.meetdayScansLoading.set(false);
          return of([]);
        })
      )
      .subscribe((meetdays: MeetDay[]) => {
        if (!meetdays.length) {
          this.meetdayScansData.set([]);
          this.meetdayFilters.set({ selectedId: null });
          this.meetdayScansLoading.set(false);
          return;
        }

        // Only store meetday metadata, students are loaded on selection
        const meetdayList = meetdays.map((meetday) => ({
          id: meetday.id!,
          name: meetday.name,
          date: meetday.date || "",
          students: [] as NormalizedMeetdayStudent[],
        }));

        this.meetdayScansData.set(meetdayList);
        this.meetdayScansLoading.set(false);

        // Auto-select the most recent concluded meetday, or the next upcoming one
        const now = new Date();
        const sortedMeetdays = [...meetdayList].sort(
          (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
        );

        // Find the most recent past meetday
        const lastConcluded = sortedMeetdays.find(
          (m) => new Date(m.date) < now
        );
        const defaultMeetday =
          lastConcluded || sortedMeetdays[sortedMeetdays.length - 1];

        if (defaultMeetday) {
          this.onMeetdaySelection(defaultMeetday.id);
        }
      });
  }

  private normalizeMeetdayStudent(
    student: MeetDayStudent,
    profile?: StudentProfile
  ): NormalizedMeetdayStudent {
    const anonymous = student.anonymousMeetdayStudent;

    const firstName = profile?.firstName || anonymous?.firstName || "";
    const lastName = profile?.lastName || anonymous?.lastName || "";
    const name = `${firstName} ${lastName}`.trim() || "Student";
    const email = profile?.emailAddress || anonymous?.emailAddress || "";

    return {
      id:
        student.studentProfileId ||
        student.id ||
        profile?.id ||
        anonymous?.emailAddress ||
        "",
      firstName,
      lastName,
      name,
      avatarUri:
        profile?.avatarUri || studentprofilePlaceholder.avatarPlaceholder,
      contactEmailAddress: email,
      homeAddress: {
        street: profile?.homeAddress?.street || anonymous?.streetName || "",
        number: profile?.homeAddress?.number || anonymous?.houseNumber || "",
        numberSuffix: profile?.homeAddress?.numberSuffix || "",
        city: profile?.homeAddress?.city || anonymous?.city || "",
        postalCode:
          profile?.homeAddress?.postalCode || anonymous?.zipCode || "",
        country: profile?.homeAddress?.country || "",
        latitude: profile?.homeAddress?.latitude ?? null,
        longitude: profile?.homeAddress?.longitude ?? null,
      },
      educations:
        profile?.educations && profile.educations.length
          ? profile.educations
          : anonymous
          ? [
              {
                level: anonymous.educationLevel || "",
                programName: anonymous.studyProgram || "",
              },
            ]
          : [],
      highestEducation:
        (profile?.educations && profile.educations.length > 0
          ? profile.educations[0]
          : null) ||
        (anonymous
          ? {
              level: anonymous.educationLevel || "",
              programName: anonymous.studyProgram || "",
            }
          : null),
      areaOfInterests: profile?.areaOfInterests || [],
      interests: profile?.interests || [],
      workExperiences: profile?.workExperiences || [],
      studentProfileCvs: profile?.studentProfileCvs || [],
      profileStrength: profile?.profileStrength || 0,
      currentUserMatchPercentage: profile?.currentUserMatchPercentage || 0,
      lookingFor: profile?.lookingFor || "",
      profileType: profile?.profileType || "",
      confirmedAttendance: student.confirmedAttendance ?? false,
    };
  }

  signUpForElection($election: Election): void {
    if (!this.profile_id()) {
      return;
    }
    this.modal
      .Modal(
        ModalCompanyElectionSignupComponent,
        "",
        "",
        { election: $election, companyId: this.profile_id() },
        [],
        { size: "lg" }
      )
      .then((result) => {
        if (result) {
          this.loadActiveElections();
        }
      })
      .catch(() => {});
  }

  showElections(): void {
    this.activeTab.set("elections");
    const el = document.getElementById("tab-profile-elections");
    if (el) el.scrollIntoView();
  }

  makeCompanyAccountCompanyElectionOwner(
    $companyId: string,
    $accountId: string
  ): void {
    this.apiCompanyService
      .addCompanyAccountRole({
        companyId: $companyId,
        accountId: $accountId,
        body: { role: RoleTypes.BedrijfsVerkiezingsbeheerder },
      })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        catchError(this.handleError("apiCompanyAccountAddRole"))
      )
      .subscribe((account) => {
        if (account && typeof account === "object" && "id" in account) {
          this.setCompanyAccount(account as Account);
        }
      });
  }

  removeCompanyAccountCompanyElectionOwnerRole(
    $companyId: string,
    $accountId: string
  ): void {
    this.apiCompanyService
      .removeCompanyAccountRole({
        companyId: $companyId,
        accountId: $accountId,
        body: { role: RoleTypes.BedrijfsVerkiezingsbeheerder },
      })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        catchError(this.handleError("apiCompanyAccountRemoveRole"))
      )
      .subscribe((account) => {
        if (account && typeof account === "object" && "id" in account) {
          this.setCompanyAccount(account as Account);
        }
      });
  }

  setCompanyAccount(accountData: Account): void {
    const currentAccounts = this.accountsData();
    const updatedAccounts = currentAccounts.map((account) =>
      account.accountId === accountData.id
        ? { ...account, account: { ...accountData } }
        : account
    );
    this.accountsData.set(updatedAccounts);
  }

  /**
   * Mark a student as scanned for a meetday
   */
  markStudentAsScanned(
    studentId: string | undefined,
    meetdayId: string | undefined
  ): void {
    if (!studentId || !meetdayId) {
      this.alertService.error("Missing student or meetday ID");
      return;
    }

    this.updatingScanStatus.set(studentId);

    this.meetDayService
      .updateMeetDayStudent({
        meetDayId: meetdayId,
        id: studentId,
        body: { confirmedAttendance: true },
      })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        catchError(() => {
          this.alertService.error("Failed to update scan status");
          this.updatingScanStatus.set(null);
          return of(null);
        })
      )
      .subscribe((result) => {
        if (result) {
          this.alertService.success("Student marked as scanned");
          this.loadCompanyMeetdayScans(); // Reload data
        }
        this.updatingScanStatus.set(null);
      });
  }

  /**
   * Unmark a student as scanned (mark as registered only)
   */
  unmarkStudentAsScanned(
    studentId: string | undefined,
    meetdayId: string | undefined
  ): void {
    if (!studentId || !meetdayId) {
      this.alertService.error("Missing student or meetday ID");
      return;
    }

    this.updatingScanStatus.set(studentId);

    this.meetDayService
      .updateMeetDayStudent({
        meetDayId: meetdayId,
        id: studentId,
        body: { confirmedAttendance: false },
      })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        catchError(() => {
          this.alertService.error("Failed to update scan status");
          this.updatingScanStatus.set(null);
          return of(null);
        })
      )
      .subscribe((result) => {
        if (result) {
          this.alertService.success("Student marked as not scanned");
          this.loadCompanyMeetdayScans(); // Reload data
        }
        this.updatingScanStatus.set(null);
      });
  }

  // ============================================
  // Translation Methods
  // ============================================

  /**
   * Field mappings for multi-language fields
   */
  private readonly translationFieldMappings: Record<
    string,
    Record<TranslationLanguage, keyof Company>
  > = {
    description: {
      nl: "description",
      en: "descriptionEn",
      de: "descriptionDe",
      fr: "descriptionFr",
      pt: "descriptionPt",
    },
    uniqueText: {
      nl: "uniqueText",
      en: "uniqueTextEn",
      de: "uniqueTextDe",
      fr: "uniqueTextFr",
      pt: "uniqueTextPt",
    },
    opportunitiesText: {
      nl: "opportunitiesText",
      en: "opportunitiesTextEn",
      de: "opportunitiesTextDe",
      fr: "opportunitiesTextFr",
      pt: "opportunitiesTextPt",
    },
  };

  /**
   * Open translation modal for a specific field
   *
   * @param fieldName - Base field name (description, uniqueText, opportunitiesText)
   * @param sourceLanguage - Source language to translate from
   */
  openTranslateModal(
    fieldName: string,
    sourceLanguage: TranslationLanguage = "nl"
  ): void {
    const fieldMapping = this.translationFieldMappings[fieldName];
    if (!fieldMapping) {
      this.alertService.error("Invalid field for translation");
      return;
    }

    // Get source text
    const entityValue = this.entity();
    const sourceField = fieldMapping[sourceLanguage];
    const sourceText = entityValue[sourceField] as string;

    // Check if source has content
    if (!sourceText || sourceText.trim().length === 0) {
      this.alertService.error(
        "Please enter content in the current tab before translating."
      );
      return;
    }

    // Determine which languages have existing content
    const languagesWithContent: TranslationLanguage[] = [];
    const allLanguages: TranslationLanguage[] = ["nl", "en", "de", "fr", "pt"];

    for (const lang of allLanguages) {
      if (lang === sourceLanguage) continue;
      const field = fieldMapping[lang];
      const content = entityValue[field] as string;
      if (content && content.trim().length > 0) {
        languagesWithContent.push(lang);
      }
    }

    // Open modal
    const modalData: ModalTranslateLanguagesData = {
      sourceLanguage,
      languagesWithContent,
      preSelectedLanguages: allLanguages.filter((l) => l !== sourceLanguage),
    };

    const modalOptions = {
      size: "md",
      centered: true,
      backdrop: "static" as const,
    };

    this.modal
      .Modal(
        ModalTranslateLanguagesComponent,
        "",
        "",
        modalData,
        [],
        modalOptions
      )
      .then((result: ModalTranslateLanguagesResult) => {
        if (result.confirmed && result.selectedLanguages.length > 0) {
          this.executeTranslation(
            fieldName,
            sourceText,
            sourceLanguage,
            result.selectedLanguages
          );
        }
      })
      .catch(() => {
        // Modal dismissed
      });
  }

  /**
   * Execute translation for a field to multiple languages
   *
   * @param fieldName - Base field name
   * @param sourceText - Text to translate
   * @param sourceLanguage - Source language
   * @param targetLanguages - Target languages
   */
  private executeTranslation(
    fieldName: string,
    sourceText: string,
    sourceLanguage: TranslationLanguage,
    targetLanguages: TranslationLanguage[]
  ): void {
    const fieldMapping = this.translationFieldMappings[fieldName];
    if (!fieldMapping) return;

    this.isTranslating.set(true);
    this.currentTranslatingField.set(fieldName);

    this.translationService
      .translateToMultiple(sourceText, targetLanguages, sourceLanguage)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (results: TranslationResults) => {
          // Apply successful translations to entity
          this.entity.update((currentEntity) => {
            const updatedEntity = { ...currentEntity };
            for (const result of results.results) {
              if (result.success && result.translatedText) {
                const targetField = fieldMapping[result.targetLanguage];
                if (targetField) {
                  (updatedEntity as Record<string, unknown>)[targetField] =
                    result.translatedText;
                }
              }
            }
            return updatedEntity;
          });

          // Show feedback
          if (results.failureCount === 0) {
            this.alertService.success(
              `Successfully translated to ${results.successCount} language(s).`
            );
          } else if (results.successCount > 0) {
            this.alertService.error(
              `Translated to ${results.successCount} language(s). ${results.failureCount} translation(s) failed.`
            );
          } else {
            this.alertService.error(
              "All translations failed. Please try again."
            );
          }

          this.isTranslating.set(false);
          this.currentTranslatingField.set("");
        },
        error: (error) => {
          console.error("Translation error:", error);
          this.alertService.error("Translation failed. Please try again.");
          this.isTranslating.set(false);
          this.currentTranslatingField.set("");
        },
      });
  }

  /**
   * Check if a specific field is currently being translated
   */
  isFieldTranslating(fieldName: string): boolean {
    return this.isTranslating() && this.currentTranslatingField() === fieldName;
  }

  /**
   * Check if a field has content in the specified language
   */
  hasFieldContent(fieldName: string, language: TranslationLanguage): boolean {
    const fieldMapping = this.translationFieldMappings[fieldName];
    if (!fieldMapping) return false;

    const entityValue = this.entity();
    const field = fieldMapping[language];
    const content = entityValue[field] as string;
    return (
      content !== null && content !== undefined && content.trim().length > 0
    );
  }

  /**
   * Error handler
   *
   * @param operation
   * @param result
   */
  handleError<T>(operation: string = "", result?: T) {
    return (error: Error): Observable<T> => {
      // Handle given operation
      switch (operation) {
        case "apiGetCompanyCurrent":
          // Do not perform any action, profile could be non-existing
          break;

        case "apiUpdateCompanyprofile":
        default:
          // Report the underlying error to Sentry so future feedback events
          // include a real stack trace + HTTP status, not just a toast.
          this.alertService.errorWithReport(
            error,
            `companyProfile:${operation}`,
            {
              companyId: this.profile_id(),
            }
          );
          break;
      }

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
